import { SEARCH_PLACEHOLDER } from 'constants/strings';


export const SEARCH_INPUT_PLACEHOLDER = SEARCH_PLACEHOLDER;
export const YOUR_EMAIL = 'Your Email';
